import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/hr/employees/$employeeId',
}).lazy(() => import('./$employeeId.index.lazy').then((d) => d.Route))
